export default "__VITE_ASSET__BaG7PEik__"